export const HEAD_OF_SALES = '1061';
